import React from 'react'

import BaseButton from '../base/base_button'

const MainButton = props => (
	<BaseButton
		{...props}
		bgColor='blue'
		fontColor='white'
	/>
)

export default MainButton
